
import { defineComponent, onMounted, ref, reactive } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as Yup from "yup";
import { useToast } from "vue-toastification";
import ApiService from "@/core/services/ApiService";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import EditSiswa from "@/components/1crm/1sekolah/siswa/edit-siswa.vue";

export default defineComponent({
  name: "Siswa",
  components: {
    ErrorMessage,
    Field,
    Form,
    EditSiswa
  },

  setup() {
    const submitButton = ref<HTMLElement | null>(null);
    const toast = useToast();
    const router = useRouter();
    const route = useRoute();

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_SISWA);
      setCurrentPageBreadcrumbs("Siswa", ["Data"]);
    });

    return {
      submitButton,
    };
  },
});
